import React from 'react';
import { SvgIcon } from '@mui/material';

export default function StonksIcon({ active, sx, ...props }) {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{ width: 24, height: 24, ...sx }}
      {...props}
    >
      {/* <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      > */}
      <rect
        width="24"
        height="24"
        rx="8"
        fill={active ? '#29EDFF' : '#4520AB'}
      />
      <path
        d="M5.54297 15.9267L9.83642 11.7661L12.4785 14.3265L15.4509 11.446L18.2147 8.85192L18.293 8.56556H14.7904M18.4561 8.07324V12.0884"
        stroke="white"
        strokeWidth="1.2"
      />
      {/* </svg> */}
    </SvgIcon>
  );
}
